import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { useEffect, useRef, useState } from 'react';
import _ from 'lodash';

import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Spinner } from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';
import { Button } from '../../../components/ui/Button';

import { useReadWeather, useCreateWeatherMutation, useUpdateWeatherMutation } from '../../../queries/weather';
import { DISPLAY_OPTIONS, WEATHER_LANGUAGES, WEATHER_UNITS } from '../../../Constants/apps';
import { resetWeatherStates, setIsEditingWeather, setWeatherBgColor, setWeatherCardColor, setWeatherTextColor } from '../../../redux/Slices/Apps/appsSlice';
import { getFormErrorMessage } from '../../../config/global';
import { useCustomToast } from '../../Contexts/ToastContext';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';
import { TitleInput } from '../../SharedComponents/Weather/Inputs';
import { useTranslation } from 'react-i18next';

import WeatherPreview from '../../SharedComponents/Weather/Previews/FullScreen/WeatherPreview';
import CornerWeatherPreview from '../../SharedComponents/Weather/Previews/Corner/CornerWeatherPreview';
import CornerAreaControl from '../../SharedComponents/Weather/CornerAreaControl';
import { BgColorInput, TextColorInput } from '../../SharedComponents/Weather/ColorController';

const defaultArea = {
    start_margin: 0,
    top_margin: 0,
    width: 35,
    height: 37,
    layout: "landscape-wide"
};


function WeatherDialog() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { showToast } = useCustomToast();

    const { openDialog } = useSelector((state) => state.global);
    const { isEditingWeather, weatherData, weatherBgColor, weatherCardColor, weatherTextColor } = useSelector((state) => state.apps);
    const access_token = localStorage.getItem('access_token');

    const isEdit = isEditingWeather;
    const [area, setArea] = useState(isEditingWeather ? weatherData?.weather?.settings?.corner_setting : defaultArea);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [localLoading, setLocalLoading] = useState(true);
    const [isInitialized, setIsInitialized] = useState(true);
    const [settings, setSettings] = useState({});
    const drawingWeatherAreaRef = useRef(null);

    const { formState: { errors }, handleSubmit, control, watch, reset, setValue } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        defaultValues: {
            title: isEdit ? weatherData?.weather.title : "",
            language: isEdit ? weatherData?.weather.settings.lang : 'en',
            location: isEdit ? weatherData?.weather.settings.location : 'Amman',
            unit: isEdit ? weatherData?.weather.settings.unit : 'c',
            display: isEdit ? weatherData?.weather.display : "FULL_SCREEN",
            location_display: isEdit
                ? (weatherData?.weather?.settings?.lang === "ar"
                    ? weatherData?.weather?.settings?.location_display
                    : "")
                : "",


        },
    });

    const locationInput = watch('location');
    const languageInput = watch('language');
    const unitInput = watch('unit');
    const displayInput = watch('display');
    const locationDisplayInput = watch('location_display');

    const createWeather = useCreateWeatherMutation();
    const editWeather = useUpdateWeatherMutation();
    const { mutate: readOneWeather, data } = useReadWeather();

    useEffect(() => {
        const updateDimensions = () => {
            if (drawingWeatherAreaRef.current) {
                const { offsetWidth, offsetHeight } = drawingWeatherAreaRef.current;
                setDimensions({ width: offsetWidth, height: offsetHeight - 10 });
            }
        };

        setIsInitialized(true);
        let payload;
        if (isEdit && access_token) {
            const updatedSettings = {
                ...settings,
                location_display: weatherData?.weather?.settings?.lang != "ar" ? data?.location?.name : weatherData?.weather?.settings?.location_display || undefined,
                lang: weatherData?.weather?.settings?.lang || 'en',
                lang_direction: weatherData?.weather?.settings?.lang === 'ar' ? 'rtl' : 'ltr',
                unit: weatherData?.weather?.settings?.unit || 'c',
                location: weatherData?.weather?.settings?.location || 'Amman',
                timeformat: '24h',
                corner_setting: weatherData?.weather?.settings?.corner_setting || area,
                textColor: weatherTextColor,
                CardColor: weatherCardColor,
                bgColor: weatherBgColor,

            };
            setSettings(updatedSettings);


            payload = { media_id: weatherData.id, token: access_token };
        } else {
            payload = { location: "Amman", language: "en" };
            const updatedSettings = {
                ...settings,
                location_display: undefined,
                lang: languageInput || 'en',
                lang_direction: languageInput === 'ar' ? 'rtl' : 'ltr',
                unit: unitInput || 'c',
                location: locationInput || 'Amman',
                timeformat: '24h',
                corner_setting: area,
                textColor: weatherTextColor,
                CardColor: weatherCardColor,
                bgColor: weatherBgColor,

            };
            setSettings(updatedSettings);

        }

        readOneWeather(payload, {
            onSuccess: (data) => {
                setLocalLoading(false);
                setIsInitialized(true);
                updateDimensions();
            },
            onError: () => {
                setLocalLoading(false);
                setIsInitialized(true);
            },
        });

        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, [isEdit]);


    useEffect(() => {

        if (isInitialized) {
            setIsInitialized(false);
            return;
        }
        setValue('location_display', '', { shouldDirty: true });
        const debounce = setTimeout(() => {
            if (locationInput?.trim()) {
                const payload = { location: locationInput, language: languageInput };

                const updatedSettings = {
                    ...settings,
                    // location_display: locationDisplayInput,
                    lang: languageInput,
                    lang_direction: languageInput === 'ar' ? 'rtl' : 'ltr',
                    // unit: unitInput,
                    location: locationInput,
                    // timeformat: '24h',
                    // corner_setting: area,
                    // textColor: weatherTextColor,
                    // bgColor: weatherBgColor,
                    // CardColor: weatherCardColor,
                };

                setSettings(updatedSettings);
                setLocalLoading(true);

                readOneWeather(payload, {
                    onSuccess: () => {
                        if (drawingWeatherAreaRef.current) {
                            const { offsetWidth, offsetHeight } = drawingWeatherAreaRef.current;
                            setDimensions({ width: offsetWidth, height: offsetHeight - 10 });
                        }
                        setLocalLoading(false);
                    },
                    onError: () => setLocalLoading(false),
                });
            }
        }, 500);

        return () => {
            clearTimeout(debounce);
        };
    }, [locationInput, languageInput]);
    useEffect(() => {
        setSettings((prev) => ({
            ...prev,
            unit: unitInput,
            location_display: locationDisplayInput,
            corner_setting: area,
            textColor: weatherTextColor,
            bgColor: weatherBgColor,
            CardColor: weatherCardColor,

        }));
    }, [unitInput, locationDisplayInput, area, weatherTextColor, weatherCardColor, weatherBgColor]);

    const formHandler = async (formData) => {

        const payload = {
            ...(isEdit && { id: weatherData.weather.id }),
            title: formData?.title,
            ...(isEdit ? {} : { location: formData?.location }),
            display: displayInput,
            settings: settings,
        };

        setLocalLoading(true);
        const mutation = isEdit ? editWeather : createWeather;
        await mutation.mutateAsync(payload, {
            onSuccess: (data) => {
                setLocalLoading(false)
                showToast('success', t('weather.weather_handling'), data?.msg);
            },
            onError: () => setLocalLoading(false),
        });
    };

    const onClose = () => {
        dispatch(resetWeatherStates())
        dispatch(toggleDialog('WeatherDialog'));
    };

    return (
        <Dialog
            visible={openDialog.WeatherDialog}
            style={{ width: '100%' }}
            header={isEdit ? t('weather.panel_modification') : t('weather.creation')}
            maximized
            blockScroll
            modal
            className="p-fluid"
            onHide={onClose}
        >
            <form onSubmit={handleSubmit(formHandler)} className="d-flex flex-column" encType="multipart/form-data">
                <div className="col-12 h-[78vh] d-flex">
                    <div className="col-7 auto-column my-5 px-3">
                        <div ref={drawingWeatherAreaRef} className="d-flex weather_preview_container border-5 border-dark h-100">
                            {localLoading ? (
                                <div className='justify-content-center align-items-center align-self-center w-100 text-center'>
                                    < Spinner variant="primary" as="span" animation="border" size="lg" role="status" className='m-3' aria-hidden="true" />
                                </div>
                            ) : data ? (
                                <div style={{ width: `${dimensions.width}px`, height: `${dimensions.height}px`, overflow: 'hidden' }}>
                                    {displayInput == "FULL_SCREEN" ?
                                        <WeatherPreview data={data} previewMode={true} settings={settings} />
                                        :
                                        <CornerWeatherPreview area={area} setArea={setArea} data={data} previewMode={true} settings={settings} />
                                    }
                                </div>
                            ) : (
                                <div className="text-muted text-center my-5 w-100">{t('weather.enter_location_preview')}</div>
                            )}
                        </div>
                    </div>

                    <div className="col-5 flex-wrap px-4 align-items-start justify-content-start py-3 border-start border-gray">
                        <TitleInput control={control} errors={errors} />

                        {/* Location Input */}
                        <div className="mb-2 col-12">
                            <label className="form-label text-capitalize">{t('weather.location')}</label>
                            <Controller
                                name="location"
                                control={control}
                                rules={{ required: t('weather.location_required') }}
                                render={({ field, fieldState }) => (
                                    <InputText
                                        id={field.name}
                                        {...field}
                                        inputRef={field.ref}
                                        className={`w-100 ${classNames({ 'p-invalid': fieldState.invalid })}`}
                                        placeholder="e.g. Amman"
                                    />
                                )}
                            />
                            {getFormErrorMessage('location', errors)}
                        </div>

                        {/* Language */}
                        <div className="mb-2 col-12">
                            <label className="form-label text-capitalize">{t('weather.language')}</label>
                            <Controller
                                name="language"
                                control={control}
                                rules={{ required: t('weather.language_required') }}
                                render={({ field, fieldState }) => (
                                    <Dropdown
                                        id={field.name}
                                        {...field}
                                        value={field.value}
                                        options={WEATHER_LANGUAGES}
                                        optionLabel="label"
                                        optionValue="value"
                                        onChange={(e) => {

                                            field.onChange(e.value)
                                        }}
                                        placeholder={t('weather.select_language')}
                                        className="w-100"
                                    />
                                )}
                            />
                            {getFormErrorMessage('language', errors)}
                        </div>

                        {/* Location Display - for non-English */}
                        {languageInput == 'ar' && (
                            <div className="mb-2 col-12">
                                <label className="form-label text-capitalize">{t('weather.location_name_display')}</label>
                                <Controller
                                    name="location_display"
                                    control={control}
                                    rules={{ required: t('weather.display_name_required') }}
                                    render={({ field, fieldState }) => (
                                        <InputText
                                            id={field.name}
                                            {...field}
                                            inputRef={field.ref}
                                            className={`w-100 ${classNames({ 'p-invalid': fieldState.invalid })}`}
                                            placeholder="e.g. عمّان"
                                        />
                                    )}
                                />
                                {getFormErrorMessage('location_display', errors)}
                            </div>
                        )}

                        {/* Unit */}
                        <div className="mb-2 col-12">
                            <label className="form-label text-capitalize">{t('weather.unit')}</label>
                            <Controller
                                name="unit"
                                control={control}
                                rules={{ required: t('weather.unit_required') }}
                                render={({ field, fieldState }) => (
                                    <Dropdown
                                        id={field.name}
                                        {...field}
                                        value={field.value}
                                        options={WEATHER_UNITS}
                                        optionLabel="label"
                                        optionValue="value"
                                        onChange={(e) => field.onChange(e.value)}
                                        placeholder={t('weather.select_unit')}
                                        className="w-100"
                                    />
                                )}
                            />
                            {getFormErrorMessage('unit', errors)}
                        </div>

                        {/* Display */}
                        <div className="mb-2 col-12">
                            <label className="form-label text-capitalize">{t('weather.display_type')}</label>
                            <Controller
                                name="display"
                                control={control}
                                rules={{ required: t('weather.display_required') }}
                                render={({ field, fieldState }) => (
                                    <Dropdown
                                        // disabled
                                        id={field.name}
                                        {...field}
                                        value={field.value}
                                        options={DISPLAY_OPTIONS}
                                        optionLabel="label"
                                        optionValue="value"
                                        onChange={(e) => field.onChange(e.value)}
                                        placeholder={t('weather.select')}
                                        className={`w-100 ${classNames({ 'p-invalid': fieldState.invalid })}`}
                                    />
                                )}
                            />
                            {getFormErrorMessage('display', errors)}
                        </div>

                        {displayInput == "CORNER" ?
                            <CornerAreaControl area={area} setArea={setArea} />
                            :
                            <div className='flex gap-3'>
                                <BgColorInput />
                                <TextColorInput />

                            </div>
                        }
                    </div>
                </div>

                <div className="col-12 text-center d-flex align-items-center justify-content-center py-4 border-top border-gray">
                    <Button className="py-2 px-4 me-3 w-auto p-button-secondary p-button-sm" label={t('buttons.cancel')} disabled={createWeather.isLoading || editWeather.isLoading} onClick={onClose} />
                    <Button type="submit" className="py-2 px-4 me-3 w-auto p-button-sm" label={isEdit ? t('buttons.publish') : t('buttons.create')} loading={createWeather.isLoading || editWeather.isLoading} />
                </div>
            </form>
        </Dialog>
    );
}

export default WeatherDialog;
